export default __webpack_public_path__ + "static/media/rear.422e345c.png";